export const chartTooltipBase = {
  trigger: 'axis' as const,
  confine: true,
  backgroundColor: '#1A1A1A',
  borderWidth: 0,
  padding: [8, 10] as [number, number],
  textStyle: { color: '#F7F8F7', fontSize: 12 },
  extraCssText: 'border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,0.18);',
};

export const chartAxisLabel = {
  fontSize: 12,
  color: '#475569',
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
};

export const chartSplitLine = {
  lineStyle: { color: 'rgba(26,26,26,0.05)', type: 'dashed' as const },
};
